import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Leftmenu from '../components/Leftmenu'
import Rightmenu from '../components/Rightmenu'
import { useOutletContext } from "react-router-dom";
import FriendCardMain from '../components/FriendCardMain'
function FriendRequest() {
    
    const { user, token } = useOutletContext();
    const [frindrequest, setFrindrequest] = useState([]);
    const getFrindrequest = () => {
        fetch('api/get-friend-requests', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => response.json())
            .then((data) => {
               
                setFrindrequest(data.data);
            }).catch((error) => {
               
            });
    }
    useEffect(() => {
        getFrindrequest();
    },[]);
  return (
     <div>
        <Header />
        <Leftmenu />
        <Rightmenu />

    <div className="main-content right-chat-active">
  <div className="middle-sidebar-bottom">
    <div className="middle-sidebar-left pe-0">
      <div className="row">
        <div className="col-xl-12">
          <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 my-4">
            <div className="card-body d-flex align-items-center p-0">
              <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900">Connection Request</h2>
           
             
            </div>
          </div>
          <div className="row ps-2 pe-2">
            {frindrequest.length > 0 && frindrequest.map((fq) => (
                <FriendCardMain data={fq} type={"request"} key={fq.id} />
            ))}
  
            

          </div>
        </div>               
      </div>
    </div>
  </div>            
</div>

    </div>
  )
}

export default FriendRequest